<div class="d-flex flex-row justify-content-center gap-3 align-items-center">

    @if(errorCount() > 0){
        <div class="d-flex flex-row gap-1 color--red-400" [tooltip]="'Errors'">
            <fa-icon [icon]="['fad', 'circle-xmark']"/>
            <span>{{errorCount()}}</span>
        </div>
    }
    @if(warningCount() > 0){
        <div class="d-flex flex-row gap-1 color--yellow-400" [tooltip]="'Warnings'">
            <fa-icon [icon]="['fad', 'triangle-exclamation']"/>
            <span>{{warningCount()}}</span>
        </div>
    }

    <button button-generic class="d-flex flex-row gap-1" [button-style]="'success'" [disabled]="(this.form()?.pending || this.form()?.invalid || this.form()?.untouched) ?? true" (click)="onSave()">
        <fa-icon [icon]="['fad', 'floppy-disk']"/>
        <span>Save Changes</span>
    </button>
    
</div>